export interface SpinnerProps {
  readonly size?: 'sm' | 'md' | 'lg'
  readonly label?: string
  readonly 'aria-hidden'?: boolean | 'true' | 'false'
  readonly className?: string | undefined
}

/**
 * Standalone/inline loading ring (components.md "Spinner" — `fx-spin`, 1s
 * linear). `prefers-reduced-motion: reduce` disables the rotation in
 * global.css's blanket motion rule (swaps to a static ring, per
 * interactions.md §6) rather than needing a second variant here.
 *
 * Decorative by default (`aria-hidden`, e.g. inside a Button that already
 * announces `aria-busy`); pass `label` for a standalone use where nothing
 * else announces the loading state.
 */
export function Spinner({ size = 'md', label, className, ...rest }: SpinnerProps) {
  const px = size === 'sm' ? 14 : size === 'lg' ? 28 : 18
  const hidden = rest['aria-hidden'] !== 'false' && !label
  return (
    <span
      className={className ? `spinner ${className}` : 'spinner'}
      role={label ? 'status' : undefined}
      aria-hidden={hidden ? 'true' : undefined}
      style={{ width: px, height: px }}
    >
      {label && <span className="sr-only">{label}</span>}
    </span>
  )
}
